import { Component, OnInit } from '@angular/core';
import { AppDataService, ConfigService } from 'app/services';
import { PartnerInsightsReportsComponent } from 'app/components/partner';
import { AppPrimengModule } from 'app/app-primeng-module';
import { AppComponent } from 'app/app.component';
import { MenuHomeEnum } from 'app/components/home';
import { MenuPermissionConfig, MenuPermissionActionEnum } from 'app/models';

export enum PartnerInsightsMenuEnum {
    Reports = 1
}

@Component({
  selector: 'partner-insights-root',
  standalone: false,
  templateUrl: './partner-insights-root.component.html',
    styleUrls: ['./partner-insights-root.component.scss',
        '../../../../../styles/m3-defaul-material-theme.scss',
        '../../../../../styles/onboardingslidermenu.scss']
})
export class PartnerInsightsRootComponent implements OnInit {

    constructor(public app: AppComponent ) { }

    public clickMenu(menuPermissionActive: string, menu: MenuHomeEnum) {
        // This method is required by app.component.ts but not used in this simple tab-based layout
        // The actual menu handling is done by the child component (partner-insights-reports)
    }

    ngOnInit(): void {
    }
}
